// Placeholder table rows while data loads (design-system .skeleton shimmer)
type Props = { cols: number; rows?: number };

const SkeletonRows = ({ cols, rows = 5 }: Props) => (
  <>
    {Array.from({ length: rows }, (_, r) => (
      <tr key={r} aria-hidden="true">
        {Array.from({ length: cols }, (_, c) => (
          <td key={c}>
            <span className="skeleton skeleton-text" />
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default SkeletonRows;
